import { Component } from 'sane-ui'
import { TweenMax, TimelineMax, Power3 } from 'gsap'
import 'gsap/ScrollToPlugin'
import debounce from 'debounce'
import Hammer from 'hammerjs'
import 'jquery-mousewheel'

const Waypoint = window.Waypoint

class FrontPage extends Component {
  constructor ($el, args) {
    super($el, args)

    // Store elements into attributes.
    this.$cover = $el.find('.cover-section')
    this.$coverScreen = this.$cover.find('.front-page__screen')

    this.$intro = $el.find('.intro-section')
    this.$introScreen = this.$intro.find('.front-page__screen')
    this.$scrollLink = $('.intro-section__scroll-link')

    this.$about = $el.find('.about-section')
    this.$aboutScreen = this.$about.find('.front-page__screen')

    this.$products = $el.find('.products-section')
    this.$productsScreen = this.$products.find('.front-page__screen')

    this.bpHelpers = args.bpHelpers
    this.tl = new TimelineMax()

    // `this` binding on callbacks.
    this.onMousewheel = this.onMousewheel.bind(this)
    this.goToAbout = this.goToAbout.bind(this)

    this.onMousewheelDebounced = debounce(this.onMousewheel, 200, true)

    const scrollLinkTl = new TimelineMax({ repeat: -1, repeatDelay: 2 })

    scrollLinkTl
      .to(this.$scrollLink.find('img'), 0.25, { y: 5, ease: Power3.easeIn })
      .to(this.$scrollLink.find('img'), 0.25, { y: 0, ease: Power3.easeOut })
      .to(this.$scrollLink.find('img'), 0.25, { y: 5, ease: Power3.easeIn })
      .to(this.$scrollLink.find('img'), 0.25, { y: 0, ease: Power3.easeOut })

    $('.site-header').addClass('site-header--clear')

    this.$about
      .find('#view-products a')
      .click((event) => {
        event.preventDefault()
        TweenMax.to(window, 0.6, { scrollTo: this.$products.offset().top, ease: Power3.easeInOut })
      })

    if (!this.bpHelpers.isScreenAtLeast('md')) {
      this.initMobile()
      return
    }

    // Check if mix-blend-mode and object-fit are supported.
    if (
      'objectFit' in document.documentElement.style === false
      || typeof window.getComputedStyle(document.body).mixBlendMode === 'undefined'
    ) {
      this.displayUI()
      return
    }

    this.init()
  }

  bindDisplayLogo () {
    new Waypoint(
      {
        element: this.$about.find('.about-section__copy').get(0),
        handler: function (dir) {
          TweenMax.to($('.site-header__logo'), 0.5, { autoAlpha: dir === 'down' ? 1 : 0 })
        },
      }
    )
  }

  initMobile () {
    this.bindDisplayLogo()

    new Waypoint(
      {
        element: this.$about.get(0),
        handler: function (dir) {
          $('.site-header').toggleClass('site-header--clear', dir === 'up')
          console.log(dir);
        },
      }
    )

    this.$scrollLink.click((event) => {
      event.preventDefault()
      TweenMax.to(window, 0.6, { scrollTo: this.$about.offset().top, ease: Power3.easeInOut })
    })

    TweenMax.set(this.$el.add('.site-footer'), { autoAlpha: 1 })
  }

  init () {
    this.$el.addClass('front-page--ca')
    TweenMax.set(this.$el, { autoAlpha: 1 })
    TweenMax.set($('html, body'), { overflow: 'hidden' })
    this.goToIntro()
  }

  goToIntro () {
    this.tl
      .set(this.$cover, { zIndex: 2 })
      .set([this.$intro, this.$introScreen, this.$cover, this.$coverScreen], { autoAlpha: 1 })
      .call(
        () => {
          this.$cover.addClass('multiply')
          this.$coverScreen.addClass('invert')

          const introVideo = this.$introScreen.get(0)
          const coverVideo = this.$coverScreen.get(0)

          introVideo.currentTime = 0
          introVideo.play()

          coverVideo.currentTime = 0
          coverVideo.play()

          this.$coverScreen.one('ended', () => {
            TweenMax.set([this.$cover, this.$introScreen], { autoAlpha: 0 })
            this.bindNavRelatedEvents()
          })
        }
    )
  }

  goToAbout () {
    this.unbindNavRelatedEvents()

    this.tl
      .clear()
      .set(this.$intro, { zIndex: 2 })
      .call(
        () => {
          this.$intro.addClass('multiply')
          this.$introScreen.addClass('invert')

          const aboutVideo = this.$aboutScreen.get(0)
          const introVideo = this.$introScreen.get(0)

          aboutVideo.currentTime = 0
          aboutVideo.play()

          introVideo.currentTime = 0
          introVideo.play()

          this.$aboutScreen.one('ended', () => {
            TweenMax.set([this.$intro, this.$aboutScreen], { autoAlpha: 0 })
            TweenMax.set($('html, body'), { overflow: 'visible' })
            TweenMax.set([this.$about, this.$products], { position: 'relative' })
            TweenMax.set([this.$products, $('.site-footer')], { autoAlpha: 1 })
            $('.site-header').removeClass('site-header--clear')
            this.bindDisplayLogo()
          })
        }
      )
      .set(
        [this.$about, this.$aboutScreen, this.$intro, this.$introScreen],
        { autoAlpha: 1, immediateRender: false },
        0.2
      )
  }

  /**
   * Navigation-related Events Binding.
   */
  bindNavRelatedEvents () {
    if (this.bpHelpers.isScreenAtLeast('xl')) {
      this.$el.on('mousewheel', this.onMousewheelDebounced)
    }

    if (typeof this.hammerManager === 'undefined') {
      this.hammerManager = new Hammer(this.$el.get(0))
      this.hammerManager.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
      this.hammerManager.on('swipeup', () => { this.goToAbout() })
    }

    this.hammerManager.get('swipe').set({ enable: this.bpHelpers.isScreenBetween('md', 'xl') })

    // Bind scroll link
    this.$scrollLink
      .one(
        'click',
        (event) => {
          event.preventDefault()
          this.goToAbout()
        }
      )
  }

  unbindNavRelatedEvents () {
    this.$el.off('mousewheel', this.onMousewheelDebounced)

    if (typeof this.hammerManager !== 'undefined') {
      this.hammerManager.get('swipe').set({ enable: false })
    }
  }

  /**
   * Mousewheel callback. We're checking which direction the user scrolled
   * and we are invoking the previous or next method accordingly.
   *
   * @param {jQuery.Event} event
   */
  onMousewheel (event) {
    if (event.deltaFactor * event.deltaY < 0) {
      this.goToAbout()
    }
  }

  displayUI () {
    TweenMax.set(this.$el.add('.site-header__logo, .site-footer'), { autoAlpha: 1 })
  }
}

export default FrontPage



// WEBPACK FOOTER //
// ./scripts/components/FrontPage.js